module.exports = __webpack_public_path__ + "assets/img/99fbc86a4158d767fb1e1d19cc841d08.png";